import { useMutation } from "@apollo/client";
import { GAME_DELETE } from "graphql/mutation/game-gql";

const useMutationGameDelete = (id) => {
  const [_setMutationGameDelete, { loading }] = useMutation(GAME_DELETE, {
    update(cache, { data }) {
      if (data?.gameDelete) {
        cache.evict({ id: cache.identify({ id, __typename: "Game" }) });
        cache.gc();
      }
    },
  });

  return {
    _setMutationGameDelete,
    loadingMutationGameDelete: loading,
  };
};

export default useMutationGameDelete;
